<!-- Header new -->
<p-toast></p-toast>
<div class="header">
  <div
    class="header_top"
    [ngClass]="{'logged-in': isLoggedIn, 'logged-out': !isLoggedIn }"
  >
    <div class="header_top_left">
      <div class="header_top_left_box border_right_black">
        <a
          [href]="
            headerData?.email
              ? 'mailto:' + headerData?.email?.trim()
              : 'mailto:support@chemrobotics.com'
          "
          class="text_decoration_none"
          target="_blank"
        >
          <div
            class="header_top_left_box_item border_right_black cursor-pointer"
          >
            <div class="header_top_left_box_item_icon">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2277_116)">
                  <path
                    d="M8.17001 8.57754C7.82171 8.80974 7.41713 8.93249 7 8.93249C6.5829 8.93249 6.17832 8.80974 5.83002 8.57754L0.0932148 4.75289C0.0613867 4.73167 0.0303789 4.70955 0 4.6868V10.9539C0 11.6724 0.583105 12.2427 1.28879 12.2427H12.7112C13.4297 12.2427 14 11.6596 14 10.9539V4.68677C13.9695 4.70957 13.9385 4.73175 13.9066 4.75299L8.17001 8.57754Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M0.548242 4.07039L6.28504 7.89507C6.50221 8.03985 6.75109 8.11223 6.99997 8.11223C7.24888 8.11223 7.49779 8.03982 7.71496 7.89507L13.4518 4.07039C13.7951 3.84166 14 3.45884 14 3.04568C14 2.33526 13.422 1.75732 12.7116 1.75732H1.28836C0.577965 1.75735 0 2.33529 0 3.04636C0 3.45884 0.204969 3.84166 0.548242 4.07039Z"
                    fill="#0032A0"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2277_116">
                    0
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span class="text_black_5">Email</span>
          </div>
        </a>
        <a class="text_decoration_none">
          <div class="header_top_left_box_item">
            <div class="header_top_left_box_item_icon">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1891_96)">
                  <path
                    d="M13.6868 6.71429C13.7061 4.45849 11.7848 2.39052 9.404 2.10456C9.35664 2.09894 9.30506 2.09039 9.25046 2.08135C9.13259 2.06182 9.0107 2.04175 8.88772 2.04175C8.39977 2.04175 8.26934 2.38451 8.235 2.58893C8.20161 2.78769 8.23346 2.95459 8.32951 3.08523C8.4911 3.30495 8.77543 3.34396 9.0038 3.37521C9.07073 3.38446 9.13388 3.39305 9.18675 3.40493C11.3258 3.88289 12.046 4.63434 12.398 6.75519C12.4066 6.80702 12.4105 6.87087 12.4146 6.93859C12.43 7.19211 12.462 7.71956 13.029 7.71956H13.0291C13.0763 7.71956 13.127 7.71549 13.1798 7.70744C13.7079 7.62719 13.6914 7.14505 13.6834 6.9134C13.6812 6.84816 13.679 6.78644 13.6845 6.7454C13.686 6.73506 13.6868 6.72468 13.6868 6.71429Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M8.74919 1.27642C8.81255 1.28099 8.87252 1.28537 8.92246 1.29302C12.435 1.83319 14.0503 3.49739 14.498 7.03737C14.5056 7.09754 14.5068 7.17093 14.508 7.24865C14.5125 7.52522 14.5217 8.10057 15.1396 8.1125L15.1587 8.1127C15.3525 8.1127 15.5067 8.05426 15.6169 7.93888C15.8093 7.73769 15.7959 7.43881 15.785 7.19861C15.7824 7.13968 15.7799 7.08417 15.7805 7.03558C15.8252 3.41511 12.6913 0.132075 9.07401 0.00998758C9.05901 0.00949068 9.0447 0.0102857 9.03024 0.012323C9.02313 0.0133665 9.00996 0.0146584 8.9874 0.0146584C8.95133 0.0146584 8.90696 0.0115279 8.8599 0.00834783C8.80301 0.00447205 8.73851 0 8.67312 0C8.09707 0 7.98755 0.409441 7.97354 0.653516C7.94124 1.21759 8.48693 1.25729 8.74919 1.27642Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M14.3285 11.6127C14.2538 11.5556 14.1766 11.4966 14.1043 11.4384C13.7208 11.1297 13.3128 10.8453 12.9182 10.5701C12.8364 10.5131 12.7545 10.456 12.6729 10.3988C12.1674 10.0437 11.713 9.8712 11.2837 9.8712C10.7055 9.8712 10.2013 10.1907 9.78523 10.8207C9.60088 11.1 9.37723 11.2358 9.1016 11.2358C8.93862 11.2358 8.75342 11.1893 8.55124 11.0975C6.91979 10.3577 5.75482 9.2234 5.08863 7.72611C4.76659 7.00243 4.87099 6.52939 5.43775 6.14439C5.75959 5.92596 6.35864 5.5193 6.31621 4.74057C6.26816 3.85624 4.31695 1.19542 3.49484 0.893213C3.14677 0.765213 2.78105 0.76402 2.4059 0.890232C1.4608 1.20795 0.782593 1.76591 0.444407 2.5037C0.117599 3.21659 0.132357 4.05366 0.48709 4.92442C1.51258 7.44198 2.95437 9.63696 4.77256 11.4483C6.55223 13.2214 8.73961 14.6738 11.2739 15.7651C11.5023 15.8633 11.7419 15.917 11.9169 15.9561C11.9765 15.9695 12.028 15.9809 12.0655 15.9912C12.0861 15.9968 12.1074 15.9998 12.1287 16L12.1487 16.0001C12.1487 16.0001 12.1487 16.0001 12.1488 16.0001C13.3408 16.0001 14.772 14.911 15.2115 13.6692C15.5966 12.5819 14.8935 12.0445 14.3285 11.6127Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M9.27641 4.15229C9.07233 4.15746 8.64763 4.16799 8.49862 4.60054C8.4289 4.80268 8.43725 4.97818 8.52346 5.12218C8.64997 5.33346 8.89236 5.3982 9.11283 5.43373C9.91238 5.56203 10.323 6.00417 10.4052 6.82504C10.4433 7.20779 10.7011 7.47507 11.032 7.47507C11.0564 7.47507 11.0815 7.47363 11.1064 7.4706C11.5044 7.42325 11.6973 7.13082 11.6799 6.60153C11.6862 6.04913 11.3972 5.422 10.9055 4.92248C10.4121 4.42141 9.81737 4.13922 9.27641 4.15229Z"
                    fill="#0032A0"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1891_96">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span class="text_black_5">{{
              headerData.mobile_number
                ? headerData.mobile_number
                : "+91-626 611 7944"
            }}</span>
          </div>
        </a>
        <a
          class="text_decoration_none"
          style="border-left: 1px solid rgba(0, 0, 0, 0.0784313725)"
          href="https://wa.me/916266117944"
          target="_blank"
        >
          <div class="header_top_left_box_item">
            <div class="header_top_left_box_item_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0,0,255.98958,255.98958"
                width="25px"
                height="25px"
                fill-rule="none"
              >
                <g
                  fill="none"
                  fill-rule="none"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path
                      d="M4.868,43.303l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98c-0.001,0 0,0 0,0h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311z"
                      fill="#ffffff"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M4.868,43.803c-0.132,0 -0.26,-0.052 -0.355,-0.148c-0.125,-0.127 -0.174,-0.312 -0.127,-0.483l2.639,-9.636c-1.636,-2.906 -2.499,-6.206 -2.497,-9.556c0.004,-10.742 8.745,-19.48 19.486,-19.48c5.21,0.002 10.105,2.031 13.784,5.713c3.679,3.683 5.704,8.577 5.702,13.781c-0.004,10.741 -8.746,19.48 -19.486,19.48c-3.189,-0.001 -6.344,-0.788 -9.144,-2.277l-9.875,2.589c-0.042,0.012 -0.084,0.017 -0.127,0.017z"
                      fill="#ffffff"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M24.014,5c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311l-10.065,2.64l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979M24.014,42.974v0v0M24.014,42.974v0v0M24.014,4v0c-11.016,0 -19.982,8.962 -19.987,19.979c-0.001,3.367 0.849,6.685 2.461,9.622l-2.585,9.439c-0.094,0.345 0.002,0.713 0.254,0.967c0.19,0.192 0.447,0.297 0.711,0.297c0.085,0 0.17,-0.011 0.254,-0.033l9.687,-2.54c2.828,1.468 5.998,2.243 9.197,2.244c11.024,0 19.99,-8.963 19.995,-19.98c0.002,-5.339 -2.075,-10.359 -5.848,-14.135c-3.775,-3.777 -8.796,-5.858 -14.139,-5.86z"
                      fill="#25D366"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M35.176,12.832c-2.98,-2.982 -6.941,-4.625 -11.157,-4.626c-8.704,0 -15.783,7.076 -15.787,15.774c-0.001,2.981 0.833,5.883 2.413,8.396l0.376,0.597l-1.595,5.821l5.973,-1.566l0.577,0.342c2.422,1.438 5.2,2.198 8.032,2.199h0.006c8.698,0 15.777,-7.077 15.78,-15.776c0.001,-4.215 -1.638,-8.179 -4.618,-11.161z"
                      fill="#25D366"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M19.268,16.045c-0.355,-0.79 -0.729,-0.806 -1.068,-0.82c-0.277,-0.012 -0.593,-0.011 -0.909,-0.011c-0.316,0 -0.83,0.119 -1.265,0.594c-0.435,0.475 -1.661,1.622 -1.661,3.956c0,2.334 1.7,4.59 1.937,4.906c0.237,0.316 3.282,5.259 8.104,7.161c4.007,1.58 4.823,1.266 5.693,1.187c0.87,-0.079 2.807,-1.147 3.202,-2.255c0.395,-1.108 0.395,-2.057 0.277,-2.255c-0.119,-0.198 -0.435,-0.316 -0.909,-0.554c-0.474,-0.238 -2.807,-1.385 -3.242,-1.543c-0.435,-0.158 -0.751,-0.237 -1.068,0.238c-0.316,0.474 -1.225,1.543 -1.502,1.859c-0.277,0.317 -0.554,0.357 -1.028,0.119c-0.474,-0.238 -2.002,-0.738 -3.815,-2.354c-1.41,-1.257 -2.362,-2.81 -2.639,-3.285c-0.277,-0.474 -0.03,-0.731 0.208,-0.968c0.213,-0.213 0.474,-0.554 0.712,-0.831c0.237,-0.277 0.316,-0.475 0.474,-0.791c0.158,-0.317 0.079,-0.594 -0.04,-0.831c-0.117,-0.238 -1.039,-2.584 -1.461,-3.522z"
                      fill="#ffffff"
                      fill-rule="evenodd"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <span class="text_black_5">Chat With Us</span>
          </div>
        </a>
      </div>
      <div class="header_top_left_box1 border_right_black">
        <a
          [href]="
            addHttpsIfMissing(
              headerData?.whatsapp_URL?.trim() ||
                'https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ'
            )
          "
          target="_blank"
          class="text_decoration_none"
        >
          <div
            class="header_top_left_box1_item cursor-pointer border_right_black"
          >
            <div class="header_top_left_box1_item_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0,0,255.98958,255.98958"
                width="25px"
                height="25px"
                fill-rule="none"
              >
                <g
                  fill="none"
                  fill-rule="none"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path
                      d="M4.868,43.303l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98c-0.001,0 0,0 0,0h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311z"
                      fill="#ffffff"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M4.868,43.803c-0.132,0 -0.26,-0.052 -0.355,-0.148c-0.125,-0.127 -0.174,-0.312 -0.127,-0.483l2.639,-9.636c-1.636,-2.906 -2.499,-6.206 -2.497,-9.556c0.004,-10.742 8.745,-19.48 19.486,-19.48c5.21,0.002 10.105,2.031 13.784,5.713c3.679,3.683 5.704,8.577 5.702,13.781c-0.004,10.741 -8.746,19.48 -19.486,19.48c-3.189,-0.001 -6.344,-0.788 -9.144,-2.277l-9.875,2.589c-0.042,0.012 -0.084,0.017 -0.127,0.017z"
                      fill="#ffffff"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M24.014,5c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311l-10.065,2.64l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979M24.014,42.974v0v0M24.014,42.974v0v0M24.014,4v0c-11.016,0 -19.982,8.962 -19.987,19.979c-0.001,3.367 0.849,6.685 2.461,9.622l-2.585,9.439c-0.094,0.345 0.002,0.713 0.254,0.967c0.19,0.192 0.447,0.297 0.711,0.297c0.085,0 0.17,-0.011 0.254,-0.033l9.687,-2.54c2.828,1.468 5.998,2.243 9.197,2.244c11.024,0 19.99,-8.963 19.995,-19.98c0.002,-5.339 -2.075,-10.359 -5.848,-14.135c-3.775,-3.777 -8.796,-5.858 -14.139,-5.86z"
                      fill="#25D366"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M35.176,12.832c-2.98,-2.982 -6.941,-4.625 -11.157,-4.626c-8.704,0 -15.783,7.076 -15.787,15.774c-0.001,2.981 0.833,5.883 2.413,8.396l0.376,0.597l-1.595,5.821l5.973,-1.566l0.577,0.342c2.422,1.438 5.2,2.198 8.032,2.199h0.006c8.698,0 15.777,-7.077 15.78,-15.776c0.001,-4.215 -1.638,-8.179 -4.618,-11.161z"
                      fill="#25D366"
                      fill-rule="nonzero"
                    ></path>
                    <path
                      d="M19.268,16.045c-0.355,-0.79 -0.729,-0.806 -1.068,-0.82c-0.277,-0.012 -0.593,-0.011 -0.909,-0.011c-0.316,0 -0.83,0.119 -1.265,0.594c-0.435,0.475 -1.661,1.622 -1.661,3.956c0,2.334 1.7,4.59 1.937,4.906c0.237,0.316 3.282,5.259 8.104,7.161c4.007,1.58 4.823,1.266 5.693,1.187c0.87,-0.079 2.807,-1.147 3.202,-2.255c0.395,-1.108 0.395,-2.057 0.277,-2.255c-0.119,-0.198 -0.435,-0.316 -0.909,-0.554c-0.474,-0.238 -2.807,-1.385 -3.242,-1.543c-0.435,-0.158 -0.751,-0.237 -1.068,0.238c-0.316,0.474 -1.225,1.543 -1.502,1.859c-0.277,0.317 -0.554,0.357 -1.028,0.119c-0.474,-0.238 -2.002,-0.738 -3.815,-2.354c-1.41,-1.257 -2.362,-2.81 -2.639,-3.285c-0.277,-0.474 -0.03,-0.731 0.208,-0.968c0.213,-0.213 0.474,-0.554 0.712,-0.831c0.237,-0.277 0.316,-0.475 0.474,-0.791c0.158,-0.317 0.079,-0.594 -0.04,-0.831c-0.117,-0.238 -1.039,-2.584 -1.461,-3.522z"
                      fill="#ffffff"
                      fill-rule="evenodd"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <span class="text_black_5">Subscribe for Latest News & Update</span>
          </div>
        </a>

        <div
          class="header_top_left_box1_item border_right_black cursor-pointer"
        >
          <div class="header_top_left_box1_item_icon1">
            <!-- Dropdown toggle -->
            <div
              class="selected-option text_black_5 d-flex align-items-center"
              (click)="toggleDropdown()"
            >
              <span>{{ selectedBrochure?.fileName || "Brochures" }}</span>
              <div class="p-x-5">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
                    fill="#303030"
                  />
                </svg>
              </div>
            </div>

            <!-- Dropdown options, shown when 'dropdownOpen' is true -->
            <div class="header_top_left_box1_item_icon1_dropdown">
              <div
                class="options header_top_left_box1_item_icon1_dropdown_content"
                *ngIf="dropdownOpen"
              >
                <ul
                  class="header_top_left_box1_item_icon1_dropdown_content_box p-x-10 text_blue_3 bg_1"
                >
                  <li
                    *ngFor="let brochure of brochures"
                    (click)="selectBrochure(brochure)"
                    class="header_top_right_body_dropdown_content_box_item cursor-pointer padding-6-6 text_blue_3 d-flex align-items-center bottom-border-1"
                  >
                    <div class="d-flex align-items-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-r-5"
                      >
                        <g clip-path="url(#clip0_1891_104)">
                          <path
                            d="M12.3667 2.24438L14.2476 2.24805L12.3667 0.404785V2.24438Z"
                            fill="#0032A0"
                          />
                          <path
                            d="M11.8916 3.19189C11.63 3.19141 11.4183 2.97925 11.4183 2.71765V0H3.50061C3.23865 0 3.02637 0.21228 3.02637 0.474243V8.92627C3.52002 8.72009 4.0614 8.60596 4.62903 8.60596C4.90942 8.60596 5.18335 8.63391 5.44836 8.68689C5.41663 8.62341 5.39844 8.55188 5.39844 8.47595C5.39844 8.21411 5.61072 8.00183 5.87256 8.00183H11.5842C11.8461 8.00183 12.0585 8.21411 12.0585 8.47595C12.0585 8.73792 11.8461 8.9502 11.5842 8.9502H6.2876C7.76477 9.5929 8.80029 11.0663 8.80029 12.7772C8.80029 13.4414 8.64404 14.0696 8.3667 14.6276H14.1428C14.4048 14.6276 14.6171 14.4153 14.6171 14.1533V3.19727L11.8916 3.19189ZM9.87695 4.74536C9.87695 5.00732 9.66467 5.2196 9.40283 5.2196H5.87256C5.61072 5.2196 5.39844 5.00732 5.39844 4.74536C5.39844 4.48352 5.61072 4.27112 5.87256 4.27112H9.40283C9.66467 4.27112 9.87695 4.4834 9.87695 4.74536ZM11.5842 7.08496H5.87256C5.61072 7.08496 5.39844 6.87256 5.39844 6.61072C5.39844 6.34875 5.61072 6.13647 5.87256 6.13647H11.5842C11.8461 6.13647 12.0585 6.34875 12.0585 6.61072C12.0585 6.87256 11.8462 7.08496 11.5842 7.08496Z"
                            fill="#0032A0"
                          />
                          <path
                            d="M7.85193 12.7772C7.85193 11.0001 6.40613 9.55444 4.62903 9.55444C2.85205 9.55444 1.40625 11.0001 1.40625 12.7772C1.40625 14.5543 2.85205 16 4.62903 16C6.40613 16 7.85193 14.5542 7.85193 12.7772ZM6.15149 13.4755L4.90503 14.3673C4.82239 14.4264 4.72571 14.4558 4.62903 14.4558C4.52942 14.4558 4.42981 14.4244 4.34583 14.3619L3.14856 13.4701C2.93848 13.3136 2.89514 13.0165 3.05151 12.8065C3.20801 12.5964 3.50513 12.553 3.71521 12.7095L4.15491 13.037V11.5267C4.15491 11.2649 4.36719 11.0526 4.62903 11.0526C4.89099 11.0526 5.10327 11.2649 5.10327 11.5267V13.0592L5.59949 12.7041C5.8125 12.5518 6.10876 12.6008 6.26111 12.8138C6.41357 13.0269 6.36438 13.323 6.15149 13.4755Z"
                            fill="#0032A0"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1891_104">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span class="p-r-10">{{ brochure.fileName }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="header_top_right"
      [ngClass]="{ 'logged-in': isLoggedIn, 'logged-out': !isLoggedIn }"
    >
      <div
        class="header_top_right_box1 border_right_black p-x-10"
        [ngClass]="{ 'logged-in': isLoggedIn, 'logged-out': !isLoggedIn }"
      >
        <div class="header_top_right_box1_btn1 p-l-5">
          <div class="header_top_right_box1_btn1 p-l-5">
            <button
              type="button"
              class="button_blue_3 rounded-pill text_white_9"
              data-bs-toggle="modal"
              data-bs-target="#demo-form"
              data-bs-dismiss="modal"
            >
              Demo Request Now
            </button>
          </div>
        </div>
        <div
          class="header_top_right_box1_btn3"
          *ngIf="isLoggedIn"
          (click)="openInNewTab(appLinks.trainingVideos)"
        >
          <button
            type="button"
            class="button_yellow_1 rounded-pill text_style_3"
          >
            Training Videos
          </button>
        </div>
        <div class="header_top_right_box1_btn2" *ngIf="!isLoggedIn">
          <div
            class="header_top_right_box1_btn2_pharma button_yellow_1 rounded-pill text_style_3 dis-flex-2 _btn2"
          >
            <a
              (click)="openInNewTab(appLinks.pharmaDatabase)"
              class="text_style_3 text_decoration_none header_top_right_box1_btn2_pharma_data"
            >
              Pharma Database
            </a>
          </div>
        </div>
      </div>
      <ng-container>
        <div *ngIf="!isSignedIn">
          <div class="header_top_right_box">
            <div
              class="header_top_right_box_item border_right_black"
              data-bs-toggle="modal"
              data-bs-target="#sign-up"
              data-bs-dismiss="modal"
            >
              <div class="header_top_right_box_item_icon">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.737469 14.5217H6.91234C7.85857 15.7185 9.32293 16.4879 10.9637 16.4879C13.8102 16.4879 16.126 14.1725 16.126 11.3266C16.126 8.48064 13.8102 6.16528 10.9637 6.16528C9.26811 6.16528 7.76088 6.98696 6.81923 8.2529C6.43756 8.17288 6.04764 8.13149 5.65393 8.13149C2.53635 8.13149 0 10.6674 0 13.7843C0 14.1915 0.330189 14.5217 0.737469 14.5217ZM10.9637 7.63994C12.9969 7.63994 14.651 9.29376 14.651 11.3266C14.651 13.3594 12.9969 15.0132 10.9637 15.0132C8.9305 15.0132 7.27636 13.3594 7.27636 11.3266C7.27636 9.29376 8.9305 7.63994 10.9637 7.63994Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M5.65397 0.487793C3.95278 0.487793 2.56885 1.87151 2.56885 3.57233C2.56885 5.27314 3.95278 6.65676 5.65397 6.65676C7.35512 6.65676 8.73905 5.27314 8.73905 3.57233C8.73905 1.87151 7.35512 0.487793 5.65397 0.487793Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M9.48869 12.0638H10.2262V12.8011C10.2262 13.2083 10.5563 13.5385 10.9636 13.5385C11.3709 13.5385 11.7011 13.2083 11.7011 12.8011V12.0638H12.4386C12.8458 12.0638 13.176 11.7337 13.176 11.3265C13.176 10.9193 12.8458 10.5892 12.4386 10.5892H11.7011V9.85183C11.7011 9.44463 11.3709 9.1145 10.9636 9.1145C10.5563 9.1145 10.2262 9.44463 10.2262 9.85183V10.5892H9.48869C9.08141 10.5892 8.75122 10.9193 8.75122 11.3265C8.75122 11.7337 9.08141 12.0638 9.48869 12.0638Z"
                    fill="#0032A0"
                  />
                </svg>
              </div>
              <span class="text_black_5">Sign Up</span>
            </div>
            <div
              class="header_top_right_box_item"
              data-bs-toggle="modal"
              data-bs-target="#sign-in"
            >
              <div class="header_top_right_box_item_icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00008 7.15788C9.97667 7.15788 11.579 5.55553 11.579 3.57894C11.579 1.60234 9.97667 0 8.00008 0C6.02349 0 4.42114 1.60234 4.42114 3.57894C4.42114 5.55553 6.02349 7.15788 8.00008 7.15788Z"
                    fill="#0032A0"
                  />
                  <path
                    d="M8.00011 8C4.51201 8 1.68433 10.8277 1.68433 14.3158C1.68433 15.2459 2.43839 16 3.36854 16H12.6317C13.5619 16 14.3159 15.2459 14.3159 14.3158C14.3159 10.8277 11.4882 8 8.00011 8Z"
                    fill="#0032A0"
                  />
                </svg>
              </div>
              <span class="text_black_5">Sign In</span>
            </div>
          </div>
        </div>
        <div
          *ngIf="isSignedIn"
          class="dis-flex-2 header_top_right_body mb-0 cursor-pointer"
          (click)="toggleUserSetting($event)"
        >
          <div class="text_black_13">
            Hi,<span class="text_black_16 p-l-5 text_align-right">{{
              userData.username
            }}</span>
          </div>
          <div class="p-x-5">
            <svg
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
                fill="#303030"
              />
            </svg>
          </div>
        </div>

        <!-- New User settings dropdown -->
        <div
          *ngIf="userSetting"
          #userSettingDialog
          class="header_top_right_body_dropdown bg_1"
        >
          <div class="header_top_right_body_dropdown_content">
            <ul
              class="header_top_right_body_dropdown_content_box p-x-10 text_blue_3"
            >
              <li
                class="header_top_right_body_dropdown_content_box_item userDetail cursor-pointer"
              >
                <div
                  class="header_top_right_body_dropdown_content_box_item_userImgContainer"
                >
                  <div
                    class="header_top_right_body_dropdown_content_box_item_userImgContainer_userImgBox"
                  >
                    <div class="imgText">
                      {{ userData?.username.charAt(0) }}
                    </div>
                  </div>
                  <h6
                    pTooltip="{{ userData?.username || '-' }}"
                    tooltipPosition="bottom"
                  >
                    {{ userData?.username || "-" }}
                  </h6>
                  <p
                    pTooltip="{{ userData?.email || '-' }}"
                    tooltipPosition="bottom"
                  >
                    {{ userData?.email || "-" }}
                  </p>
                  <hr />
                </div>
              </li>
              <li
                class="header_top_right_body_dropdown_content_box_item cursor-pointer padding-6-10 text_blue_3"
              >
                <a
                  class="header_top_right_body_dropdown_content_box_item_a"
                  href="https://www.chemrobotics.com/profile?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="header_top_right_body_dropdown_content_box_item_icon"
                  >
                    <path
                      d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    ></path>
                  </svg>
                  <a>
                    <span class="p-r-10">Profile</span>
                  </a>
                </a>
              </li>
              <li
                class="header_top_right_body_dropdown_content_box_item cursor-pointer padding-6-10 text_blue_3"
                routerLink="https://www.chemrobotics.com/edit_profile?access_key={{
                  accessKey
                }}"
              >
                <a
                  class="header_top_right_body_dropdown_content_box_item_a"
                  href="https://www.chemrobotics.com/edit_profile?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="header_top_right_body_dropdown_content_box_item_icon"
                  >
                    <path
                      d="M2.21232 14.0601C1.91928 12.6755 1.93115 11.2743 2.21316 9.94038C3.32308 10.0711 4.29187 9.7035 4.60865 8.93871C4.92544 8.17392 4.50032 7.22896 3.62307 6.53655C4.3669 5.3939 5.34931 4.39471 6.53554 3.62289C7.228 4.50059 8.17324 4.92601 8.93822 4.60914C9.7032 4.29227 10.0708 3.32308 9.93979 2.21281C11.3243 1.91977 12.7255 1.93164 14.0595 2.21364C13.9288 3.32356 14.2964 4.29235 15.0612 4.60914C15.8259 4.92593 16.7709 4.5008 17.4633 3.62356C18.606 4.36739 19.6052 5.3498 20.377 6.53602C19.4993 7.22849 19.0739 8.17373 19.3907 8.93871C19.7076 9.70369 20.6768 10.0713 21.7871 9.94028C22.0801 11.3248 22.0682 12.726 21.7862 14.06C20.6763 13.9293 19.7075 14.2969 19.3907 15.0616C19.0739 15.8264 19.4991 16.7714 20.3763 17.4638C19.6325 18.6064 18.6501 19.6056 17.4638 20.3775C16.7714 19.4998 15.8261 19.0743 15.0612 19.3912C14.2962 19.7081 13.9286 20.6773 14.0596 21.7875C12.675 22.0806 11.2738 22.0687 9.93989 21.7867C10.0706 20.6768 9.70301 19.708 8.93822 19.3912C8.17343 19.0744 7.22848 19.4995 6.53606 20.3768C5.39341 19.633 4.39422 18.6506 3.62241 17.4643C4.5001 16.7719 4.92552 15.8266 4.60865 15.0616C4.29179 14.2967 3.32259 13.9291 2.21232 14.0601ZM3.99975 12.2104C5.09956 12.5148 6.00718 13.2117 6.45641 14.2963C6.90564 15.3808 6.75667 16.5154 6.19421 17.5083C6.29077 17.61 6.38998 17.7092 6.49173 17.8056C7.4846 17.2432 8.61912 17.0943 9.70359 17.5435C10.7881 17.9927 11.485 18.9002 11.7894 19.9999C11.9295 20.0037 12.0697 20.0038 12.2099 20.0001C12.5143 18.9003 13.2112 17.9927 14.2958 17.5435C15.3803 17.0942 16.5149 17.2432 17.5078 17.8057C17.6096 17.7091 17.7087 17.6099 17.8051 17.5081C17.2427 16.5153 17.0938 15.3807 17.543 14.2963C17.9922 13.2118 18.8997 12.5149 19.9994 12.2105C20.0032 12.0704 20.0033 11.9301 19.9996 11.7899C18.8998 11.4856 17.9922 10.7886 17.543 9.70407C17.0937 8.61953 17.2427 7.48494 17.8052 6.49204C17.7086 6.39031 17.6094 6.2912 17.5076 6.19479C16.5148 6.75717 15.3803 6.9061 14.2958 6.4569C13.2113 6.0077 12.5144 5.10016 12.21 4.00044C12.0699 3.99666 11.9297 3.99659 11.7894 4.00024C11.4851 5.10005 10.7881 6.00767 9.70359 6.4569C8.61904 6.90613 7.48446 6.75715 6.49155 6.1947C6.38982 6.29126 6.29071 6.39047 6.19431 6.49222C6.75668 7.48509 6.90561 8.61961 6.45641 9.70407C6.00721 10.7885 5.09967 11.4855 3.99995 11.7899C3.99617 11.93 3.9961 12.0702 3.99975 12.2104ZM11.9997 15.0002C10.3428 15.0002 8.99969 13.657 8.99969 12.0002C8.99969 10.3433 10.3428 9.00018 11.9997 9.00018C13.6565 9.00018 14.9997 10.3433 14.9997 12.0002C14.9997 13.657 13.6565 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"
                    ></path>
                  </svg>
                  <a>
                    <span class="p-r-10">Settings</span>
                  </a>
                </a>
              </li>
              <li
                class="header_top_right_body_dropdown_content_box_item cursor-pointer padding-6-10 text_blue_3"
                (click)="LogoutClick()"
              >
                <a class="header_top_right_body_dropdown_content_box_item_a">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="header_top_right_body_dropdown_content_box_item_icon"
                  >
                    <path
                      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2713 2 18.1757 3.57078 20.0002 5.99923L17.2909 5.99931C15.8807 4.75499 14.0285 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.029 20 15.8816 19.2446 17.2919 17.9998L20.0009 17.9998C18.1765 20.4288 15.2717 22 12 22ZM19 16V13H11V11H19V8L24 12L19 16Z"
                    ></path>
                  </svg>
                  <a>
                    <span class="p-r-10">Sign Out</span>
                  </a>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="header_bottom"
    [ngClass]="
      transparent ? 'header_background_transparent' : 'header_background'
    "
  >
    <div class="header_bottom_logo">
      <img
        class="header_bottom_logo_img"
        [src]="
          headerData.header_logo
            ? logoUrl + headerData.header_logo
            : 'https://www.chemrobotics.com/agropat/uploads/thumbnail/header_logo_1726637785151.png'
        "
        routerLink="/"
        style="cursor: pointer"
      />
    </div>
    <div class="header_bottom_center">
      <div
        class="header_bottom_center_box cursor-pointer"
        (click)="openInNewTab(appLinks.home + '?access_key=' + accessKey)"
      >
        <a
          class="header_bottom_center_box_item"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          "
          >Home</a
        >
      </div>
      <div
        (mouseenter)="enterHeaderDesc()"
        (mouseleave)="leaveHeaderDesc()"
        class="header_bottom_center_box1"
        [ngClass]="{ header_bottom_center_box_selected: descDropdown }"
      >
        <p
          class="header_bottom_center_box1_item mb-0"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box1_text'
              : 'header_bottom_center_box1_text1'
          "
        >
          Who we are
          <svg
            *ngIf="overHeaderDesc || overDescDropdown || !transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
          <svg
            *ngIf="!overHeaderDesc && !overDescDropdown && transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="white"
            />
          </svg>
        </p>
        <div
          class="header_bottom_center_box1_dropdown descDropdown"
          [ngClass]="{ open: descDropdown }"
        >
          <ul
            (mouseenter)="enterDescBox()"
            (mouseleave)="leaveDescBox()"
            class="header_bottom_center_box1_dropdown_list"
          >
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.aboutUs)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >About Us</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.advisory)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Advisory Panel</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.awardsRecognition)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Awards & Recognitions</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.clients)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Client</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.gallery)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Gallery</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.ourEvents)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Our Events</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.ourPartners)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Our Partners</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.ourStory)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Our Story</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.ourTeam)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Our Teams</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.pressRelease)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Press Release</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        (mouseenter)="enterHeader()"
        (mouseleave)="leaveHeader()"
        class="header_bottom_center_box"
        [ngClass]="{ header_bottom_center_box_selected: showProducts }"
      >
        <p
          class="mb-0"
          [ngClass]="[
            showProducts
              ? 'header_bottom_center_box_selected_item'
              : 'header_bottom_center_box_item',
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          ]"
        >
          Databases
          <svg
            *ngIf="showProducts || !transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
          <svg
            *ngIf="!showProducts && transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="white"
            />
          </svg>
        </p>
      </div>
      <div
        (mouseenter)="enterHeaderServices()"
        (mouseleave)="leaveHeaderServices()"
        class="header_bottom_center_box1"
        [ngClass]="{ header_bottom_center_box_selected: servicesDropdown }"
      >
        <p
          class="header_bottom_center_box1_item mb-0"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box1_text'
              : 'header_bottom_center_box1_text1'
          "
        >
          Services
          <svg
            *ngIf="overHeaderservices || overServicesDropdown || !transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
          <svg
            *ngIf="!overHeaderservices && !overServicesDropdown && transparent"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="white"
            />
          </svg>
        </p>
        <div
          (mouseenter)="enterServicesBox()"
          (mouseleave)="leaveServicesBox()"
          class="header_bottom_center_box1_dropdown servicesDropdown"
          [ngClass]="{ open: servicesDropdown }"
        >
          <ul class="header_bottom_center_box1_dropdown_list text_blue_3">
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.autoRegulatory)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Auto-Regulatory</span
                >
              </a>
            </li>
            <li
              class="header_bottom_center_box1_dropdown_list_item cursor-pointer"
              (click)="openInNewTab(appLinks.patentIndia)"
            >
              <a class="header_bottom_center_box1_dropdown_list_item_link">
                <span
                  class="header_bottom_center_box1_dropdown_list_item_link_text text_blue_3"
                  >Patents India</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="header_bottom_center_box cursor-pointer"
        (click)="openInNewTab(appLinks.career)"
      >
        <a
          class="header_bottom_center_box_item"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          "
        >
          Career At
        </a>
      </div>
      <div
        class="header_bottom_center_box cursor-pointer"
        (click)="openInNewTab(appLinks.contactUs)"
      >
        <a
          class="header_bottom_center_box_item"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          "
        >
          Contact Us
        </a>
      </div>
      <div class="header_bottom_center_box">
        <a
          class="header_bottom_center_box_item"
          href="https://chemrobotics.in/ "
          [ngClass]="
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          "
          >Chemrobotics Times</a
        >
      </div>
      <div class="header_bottom_center_box">
        <a
          class="header_bottom_center_box_item"
          href=" https://buychem.chemrobotics.com/"
          [ngClass]="
            transparent
              ? 'header_bottom_center_box_text'
              : 'header_bottom_center_box_text1'
          "
          >Buy Chem</a
        >
      </div>
    </div>
    <div class="header_bottom_right">
      <div class="header_bottom_right_btn">
        <button
          type="button"
          class="header_bottom_right_btn_pharma rounded-pill"
        >
          <a
            class="text_decoration_none text_white_2 header_bottom_right_btn_pharma_box"
            href="https://chemroboticspharma.com/pharmVetPat"
            traget="_blank"
            >Pharma Database</a
          >
        </button>
      </div>
      <div class="header_bottom_right_boxes">
        <div id="google_translate_element"></div>
      </div>
      <div class="header_bottom_right_hamburger">
        <a *ngIf="!transparent && !showMenu" (click)="openMenu(true)"
          ><img src="../../../assets/icons/hamburger.png" alt="menu"
        /></a>
        <a *ngIf="transparent && !showMenu" (click)="openMenu(true)"
          ><img src="../../../assets/icons/hamburger_white.png" alt="menu"
        /></a>
        <a
          *ngIf="showMenu"
          class="header_bottom_right_hamburger_cross"
          (click)="openMenu(false)"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.94037 4.82987L3.51804 1.40754C2.93559 0.825091 1.98974 0.825091 1.40729 1.40754C0.824847 1.98999 0.824847 2.93584 1.40729 3.51828L4.82962 6.94061L1.40729 10.3628C0.824847 10.9452 0.824847 11.8911 1.40729 12.4735C1.98974 13.056 2.93559 13.056 3.51804 12.4735L6.94037 9.05136L10.3625 12.4735C10.945 13.056 11.8908 13.056 12.4733 12.4735C13.0557 11.8911 13.0557 10.9452 12.4733 10.3628L9.05112 6.94061L12.4733 3.51828C13.0557 2.93584 13.0557 1.98999 12.4733 1.40754C11.8908 0.825091 10.945 0.825091 10.3625 1.40754L6.94037 4.82987Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div
    (mouseenter)="enterProductBox()"
    (mouseleave)="leaveProductBox()"
    class="header_products"
    *ngIf="showProducts"
  >
    <div class="header_products_right">
      <div class="header_products_right_box">
        <img
          class="header_products_right_box_img"
          src="../../../assets/img/header_products_right.png"
        />
      </div>
    </div>
    <div class="header_products_left">
      <div class="header_products_left_box">
        <div class="header_products_left_box_grid">
          <div class="header_products_left_box_grid_col">
            <p class="text_black_2">AGROCHEMICAL / PESTICIDE DATABASE</p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://agropatdiscovery.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  style="display: flex; align-items: center; gap: 10px"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/agropatdiscovery.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <!-- Text with Superscript -->
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    style="display: flex; align-items: center"
                  >
                    AgroPat Ultimate Discovery Suite
                    <sup style="font-weight: bold; font-size: 0.7em"> N </sup>
                  </span>
                  <!-- SVG Icon -->
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://www.chemrobotics.com/agropat-ultimate/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/genericsuite.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >AgroPat Ultimate Discovery Suite - Classic</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://www.chemrobotics.com/agro-suite/agropat-ultimate-2?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/genericsuite.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >AgroPat Ultimate Generic Suite</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://www.mrl.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                >
                  <img
                    src="../../../assets/munu-icons/mrl.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Global MRL Database</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://ipd.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/ipd.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Indian Pestcide Database (IPD)<sup
                      style="font-weight: bold; font-size: 0.7em"
                    >
                      N
                    </sup>
                    - Indian Agrochem Approval Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://www.gapd.chemrobotics.com/search?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/gapd.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Global Agro Product Directory (GAPD) - Global Agrochem
                    Approval Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
            </ul>
            <p class="text_black_2">PHARMACEUTICAL API GENERIC DATABASES</p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://chemroboticspharma.com/pharmVetPat?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/pharma.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >PharmVetPat Ultimate - API Generic Suite</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://spc.chemrobotics.com/search?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/spc.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >SPC Database - Europe Generic Constraning Date Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://imd.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/imd.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Indian Medicine Database (IMD)</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <p class="text_black_2">OTHER DATABASE</p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <!-- <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  >
                  <img
                    src="../../../assets/munu-icons/xim1.0.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >AgroPharm XIM 1.0 DB<sup
                      style="font-weight: bold; font-size: 0.7em"
                    >
                      N
                    </sup>
                    - Supplier, Buyer, Vol. & Pricing Info. Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://agropharmeximnew.chemrobotics.com/#/agropharm-xim-new-beta/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  >
                  <img
                    src="../../../assets/munu-icons/xim2.0.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >AgroPharm XIM 2.0 DB<sup
                      style="font-weight: bold; font-size: 0.7em"
                    >
                      N
                    </sup>
                    - Supplier, Buyer, Vol. & Pricing Info. Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li> -->
              <li class="header_products_left_box_grid_col_list_item py-0">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="#"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/gbe.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Global Business Events - Trade Shows, Exhibitions, &
                    Conferences Beta</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/comingsoonNew.gif"
                    width="50"
                    alt="Coming soon"
                  />
                </a>
              </li>
            </ul>
          </div>
          <div class="header_products_left_box_grid_col">
            <p class="text_black_2">
              AGROCHEM, PHARMACHEM & SPECIALTY CHEMICAL DATABASES
            </p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="http://www.technicalroute.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/technical route.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Technical Routes<sup
                      style="font-weight: bold; font-size: 0.7em"
                    >
                      N
                    </sup>
                    - Essential Chemical Manufacturing Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://www.chemrobotics.com/agro-suite/technical-routes?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/technicalold.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Technical Routes - Essential Chemical Manufacturing
                    Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>

              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://chemitracker.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/chemitracker.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >ChemiTracker - A Supplier Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item py-0">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="#"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/kuk.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >Knō Ure KompeteR - Global Innovation Watch</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/comingsoonNew.gif"
                    width="50"
                    alt="Coming soon"
                  />
                </a>
              </li>
            </ul>
            <p class="text_black_2">
              AGROCHEMICAL & PHARMACEUTICAL PATENT DATABASES PATENT DATABASE
            </p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://betaquikpatent.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/quickpatent.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >QuikPatent<sup style="font-weight: bold; font-size: 0.7em">
                      N
                    </sup>
                    - Agrochemical Constraining Patent Guide
                  </span>
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://quikpatent.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/quickold.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >QuikPatent - Agrochemical Constraining Patent Guide</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>

              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="http://activepatents.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/active.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >ActivePatents<sup
                      style="font-weight: bold; font-size: 0.7em"
                    >
                      N
                    </sup>
                    - Pharmaceutical API Constraining Patent Guide
                  </span>
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                  <img
                    src="../../../assets/icons/new1.gif"
                    alt="Icon"
                    style="width: 50px"
                  />
                </a>
              </li>
            </ul>

            <p class="text_black_2">CHEMICAL BUY-SALE PLATFORM</p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://buychem.chemrobotics.com/?access_key={{
                    accessKey
                  }} "
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/buyndsell.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >BuyChem - Chemical Buy-Sale Platform</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <p class="text_black_2">JOB PORTAL</p>
            <ul class="header_products_left_box_grid_col_list text_blue_2">
              <li class="header_products_left_box_grid_col_list_item">
                <a
                  class="header_products_left_box_grid_col_list_item_link"
                  href="https://jobs.chemrobotics.com/?access_key={{
                    accessKey
                  }}"
                  target="_blank"
                  ><!-- Munu icon -->
                  <img
                    src="../../../assets/munu-icons/jobs.png"
                    alt="Menu Icon"
                    class="header_products_left_box_grid_col_list_item_link_menuIcon"
                  />
                  <span
                    class="header_products_left_box_grid_col_list_item_link_text text_blue_3"
                    >ChemRobotics Jobs</span
                  >
                  <svg
                    width="9"
                    height="13"
                    viewBox="0 0 9 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11117 5.99274L2.32601 0.207681C2.19221 0.0737718 2.01359 0 1.82314 0C1.63268 0 1.45406 0.0737718 1.32026 0.207681L0.894224 0.633613C0.616998 0.911155 0.616998 1.36224 0.894224 1.63936L5.75217 6.4973L0.888834 11.3606C0.75503 11.4945 0.681152 11.6731 0.681152 11.8634C0.681152 12.054 0.75503 12.2325 0.888834 12.3665L1.31487 12.7923C1.44878 12.9262 1.62729 13 1.81774 13C2.0082 13 2.18682 12.9262 2.32062 12.7923L8.11117 7.00198C8.2453 6.86764 8.31896 6.68829 8.31854 6.49762C8.31896 6.30622 8.2453 6.12697 8.11117 5.99274Z"
                      fill="#0032A0"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="header_menu" *ngIf="showMenu">
    <div class="header_menu_list">
      <div class="header_menu_list_item" (click)="openInNewTab(appLinks.home)">
        <a class="header_menu_list_item_text">Home</a>
      </div>
      <div
        (click)="selectedMenu = selectedMenu === 'our_info' ? '' : 'our_info'"
        class="header_menu_list_item text_style_4"
      >
        Who we are
        <div class="header_menu_list_item_icon">
          <svg
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
        </div>
      </div>
      <div
        *ngIf="selectedMenu === 'our_info'"
        class="header_menu_list_dropdown"
      >
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_box">
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.aboutUs)"
            >
              About Us
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.advisory)"
            >
              Advisory
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.awardsRecognition)"
            >
              Awards & Recognition
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.clients)"
            >
              Client
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.gallery)"
            >
              Gallery
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.ourEvents)"
            >
              Our Events
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.ourPartners)"
            >
              Our Partners
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.ourStory)"
            >
              Our Story
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.ourTeam)"
            >
              Our Teams
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item text_blue_3"
              (click)="openInNewTab(appLinks.pressRelease)"
            >
              Press Release
            </div>
          </div>
        </div>
      </div>
      <div
        (click)="selectedMenu = selectedMenu === 'products' ? '' : 'products'"
        class="header_menu_list_item text_style_4"
      >
        Databases
        <div class="header_menu_list_item_icon">
          <svg
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
        </div>
      </div>
      <div
        *ngIf="selectedMenu === 'products'"
        class="header_menu_list_dropdown"
      >
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            AGROCHEMICAL / PESTICIDE DATABASE
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://agropatdiscovery.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 10px;
                  text-align: center;
                "
              >
                <!-- Text with Superscript -->
                <span
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                  "
                >
                  AgroPat Ultimate Discover Suite
                  <sup
                    style="
                      color: rgb(64, 140, 255);
                      font-weight: bold;
                      font-size: 0.7em;
                      margin-left: 5px;
                    "
                  >
                    N
                  </sup>
                </span>

                <!-- Image Parallel to the Name -->
                <img
                  src="../../../assets/icons/new1.gif"
                  alt="Icon"
                  style="width: 50px"
                />
              </a>
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.chemrobotics.com/agropat-ultimate/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >AgroPat Ultimate Discover Suite - Classic</a
              >
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.chemrobotics.com/agro-suite/agropat-ultimate-2?access_key={{
                  accessKey
                }}"
                target="_blank"
                >AgroPat Ultimate Generic Suite</a
              >
            </div>
            <!-- <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.chemrobotics.com/agro-suite/mrl-database?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Global MRL Database</a
              >
            </div> -->
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.mrl.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Global MRL Database</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://ipd.chemrobotics.com/?access_key={{ accessKey }}"
                target="_blank"
                >Indian Pestcide Database (IPD)<sup
                  style="font-weight: bold; font-size: 0.7em"
                >
                  N
                </sup>
                - Indian Agrochem Approval Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <!-- <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://ipd.chemrobotics.com/#/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Indian Pesticide Database (Table View)</a
              >
            </div> -->
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.gapd.chemrobotics.com/search?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Global Agro Product Directory (GAPD) - Global Agrochem Approval
                Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
          </div>
        </div>
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            PHARMACEUTICAL API GENERIC DATABASES
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://chemroboticspharma.com/pharmVetPat?access_key={{
                  accessKey
                }}"
                target="_blank"
                >PharmVetPat Ultimate - API Generic Suite</a
              >
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://spc.chemrobotics.com/search?access_key={{
                  accessKey
                }}"
                target="_blank"
                >SPC Database - Europe Generic Constraning Date Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://imd.chemrobotics.com/?access_key={{ accessKey }}"
                target="_blank"
                >Indian Medicine Database (IMD)</a
              >
            </div>
          </div>
        </div>
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            OTHER DATABASE
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <!-- <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >AgroPharm XIM 1.0 DB<sup
                  style="font-weight: bold; font-size: 0.7em"
                >
                  N
                </sup>
                - Supplier, Buyer, Vol. & Pricing Info. Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://agropharmeximnew.chemrobotics.com/#/agropharm-xim-new-beta/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >AgroPharm XIM 2.0 DB<sup
                  style="font-weight: bold; font-size: 0.7em"
                >
                  N
                </sup>
                - Supplier, Buyer, Vol. & Pricing Info. Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div> -->
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a href="#"
                >Global Business Events - Trade Shows, Exhibitions, &
                Conferences Beta</a
              >
              <img
                src="../../../assets/icons/comingsoonNew.gif"
                width="50"
                alt="Coming soon"
              />
            </div>
          </div>
        </div>
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            AGROCHEM, PHARMACHEM & SPECIALTY CHEMICAL DATABASES
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="http://www.technicalroute.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Technical Routes<sup
                  style="font-weight: bold; font-size: 0.7em"
                >
                  N </sup
                >- Essential Chemical Manufacturing Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://www.chemrobotics.com/agro-suite/technical-routes?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Technical Routes - Essential Chemical Manufacturing Guide</a
              >
            </div>

            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://chemitracker.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >Chemi Tracker - A Supplier Guide</a
              >
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a href="#">Knō Ure KompeteR - Global Innovation Watch</a>
              <img
                src="../../../assets/icons/comingsoonNew.gif"
                width="50"
                alt="Coming soon"
              />
            </div>
          </div>
        </div>
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            AGROCHEMICAL & PHARMACEUTICAL PATENT DATABASES PATENT DATABASE
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://betaquikpatent.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >QuikPatent<sup style="font-weight: bold; font-size: 0.7em">
                  N
                </sup>
                - Agrochemical Constraining Patent Guide</a
              >
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://quikpatent.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >QuikPatent - Agrochemical Constraining Patent Guide</a
              >
            </div>

            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="http://activepatents.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >ActivePatents<sup style="font-weight: bold; font-size: 0.7em">
                  N
                </sup>
                - Pharmaceutical API Constraining Patent Guide
              </a>
              <img
                src="../../../assets/icons/new1.gif"
                alt="Icon"
                style="width: 50px"
              />
            </div>
          </div>
        </div>

        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            CHEMICAL BUY-SALE PLATFORM
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              <a
                href="https://buychem.chemrobotics.com/?access_key={{
                  accessKey
                }}"
                target="_blank"
                >BuyChem - Chemical Buy-Sale Platform</a
              >
            </div>
          </div>
        </div>
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_heading text_white_10">
            <a
              href="https://jobs.chemrobotics.com/?access_key={{ accessKey }}"
              target="_blank"
              >JOB PORTAL</a
            >
          </div>
          <div class="header_menu_list_dropdown_content_box">
            <div class="header_menu_list_dropdown_content_box_item text_blue_3">
              ChemRobotics Jobs
              <svg
                width="9"
                height="13"
                viewBox="0 0 9 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.11166 5.99274L2.3265 0.207681C2.19269 0.0737718 2.01408 0 1.82362 0C1.63317 0 1.45455 0.0737718 1.32075 0.207681L0.894712 0.633613C0.617487 0.911155 0.617487 1.36224 0.894712 1.63936L5.75266 6.4973L0.889322 11.3606C0.755518 11.4945 0.681641 11.6731 0.681641 11.8634C0.681641 12.054 0.755518 12.2325 0.889322 12.3665L1.31536 12.7923C1.44927 12.9262 1.62778 13 1.81823 13C2.00869 13 2.1873 12.9262 2.32111 12.7923L8.11166 7.00198C8.24578 6.86764 8.31945 6.68829 8.31903 6.49762C8.31945 6.30622 8.24578 6.12697 8.11166 5.99274Z"
                  fill="#0032A0"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        (click)="selectedMenu = selectedMenu === 'services' ? '' : 'services'"
        class="header_menu_list_item text_style_4"
      >
        Services
        <div class="header_menu_list_item_icon">
          <svg
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
              fill="#303030"
            />
          </svg>
        </div>
      </div>
      <div
        *ngIf="selectedMenu === 'services'"
        class="header_menu_list_dropdown"
      >
        <div class="header_menu_list_dropdown_content">
          <div class="header_menu_list_dropdown_content_box text_blue_5">
            <div
              class="header_menu_list_dropdown_content_box_item cursor-pointer"
              (click)="openInNewTab('/agro-regulatory')"
            >
              Agro-Regulatory
            </div>
            <div
              class="header_menu_list_dropdown_content_box_item cursor-pointer"
              (click)="openInNewTab('/patent-india')"
            >
              Patents India
            </div>
          </div>
        </div>
      </div>
      <div class="header_menu_list_item">
        <a
          class="header_menu_list_item_text"
          (click)="openInNewTab('https://chemrobotics.in/')"
          >ChemRobotics Times</a
        >
      </div>
      <div
        class="header_menu_list_item cursor-pointer"
        (click)="openInNewTab(appLinks.contactUs)"
      >
        <a class="header_menu_list_item_text">Contact Us</a>
      </div>
      <div
        class="header_menu_list_item cursor-pointer"
        (click)="openInNewTab(appLinks.career)"
      >
        <a class="header_menu_list_item_text">Career At</a>
      </div>
      <div class="header_menu_list_item">
        <a
          class="header_menu_list_item_text"
          (click)="openInNewTab('https://buychem.chemrobotics.com/')"
          >Buy Chem</a
        >
      </div>
    </div>
    <div class="header_menu_buttons">
      <div class="header_menu_buttons_item">
        <div id="google_translate_element"></div>
      </div>
      <div
        class="header_menu_buttons_item"
        (click)="openInNewTab(appLinks.trainingVideos)"
        *ngIf="isLoggedIn"
      >
        <button type="button" class="button_blue_2 rounded-pill text_white_9">
          Training Videos
        </button>
      </div>
      <div class="header_menu_buttons_item cursor-pointer">
        <button
          type="button"
          class="button_white_2 rounded-pill text_blue_5"
          data-bs-toggle="modal"
          data-bs-target="#demo-form"
          data-bs-dismiss="modal"
        >
          Demo Request Now
        </button>
      </div>
      <div class="header_menu_buttons_item">
        <div
          type="button"
          class="button_blue_2 rounded-pill dis-flex-2 header_menu_buttons_item_box"
        >
          <a
            (click)="openInNewTab(appLinks.pharmaDatabase)"
            class="button_link text_decoration_none text_white_9 header_menu_buttons_item_box_pharma"
            >Pharma Database</a
          >
        </div>
      </div>
    </div>
    <div class="header_menu_bottom text_white_8">
      <a
        [href]="
          headerData?.email
            ? 'mailto:' + headerData?.email?.trim()
            : 'mailto:support@chemrobotics.com'
        "
        class="text_decoration_none"
        target="_blank"
      >
        <div class="header_menu_bottom_item">
          <div class="header_menu_bottom_item_icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1596_24230)">
                <path
                  d="M8.17001 8.57827C7.82171 8.81047 7.41713 8.93322 7 8.93322C6.5829 8.93322 6.17832 8.81047 5.83002 8.57827L0.0932148 4.75362C0.0613867 4.7324 0.0303789 4.71028 0 4.68753V10.9546C0 11.6732 0.583105 12.2434 1.28879 12.2434H12.7112C13.4297 12.2434 14 11.6603 14 10.9546V4.6875C13.9695 4.7103 13.9385 4.73248 13.9066 4.75373L8.17001 8.57827Z"
                  fill="white"
                />
                <path
                  d="M0.548242 4.07087L6.28504 7.89555C6.50221 8.04034 6.75109 8.11272 6.99997 8.11272C7.24888 8.11272 7.49779 8.04031 7.71496 7.89555L13.4518 4.07087C13.7951 3.84214 14 3.45933 14 3.04617C14 2.33575 13.422 1.75781 12.7116 1.75781H1.28836C0.577965 1.75784 0 2.33578 0 3.04685C0 3.45933 0.204969 3.84214 0.548242 4.07087Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1596_24230">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          Email
        </div>
      </a>
      <div class="header_menu_bottom_item">
        <div class="header_menu_bottom_item_icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6868 6.71356C13.7061 4.45776 11.7848 2.38979 9.404 2.10382C9.35664 2.09821 9.30506 2.08966 9.25046 2.08062C9.13259 2.06109 9.0107 2.04102 8.88772 2.04102C8.39977 2.04102 8.26934 2.38377 8.235 2.5882C8.20161 2.78695 8.23346 2.95386 8.32951 3.08449C8.4911 3.30422 8.77543 3.34323 9.0038 3.37448C9.07073 3.38372 9.13388 3.39232 9.18675 3.4042C11.3258 3.88216 12.046 4.63361 12.398 6.75446C12.4066 6.80628 12.4105 6.87013 12.4146 6.93786C12.43 7.19138 12.462 7.71883 13.029 7.71883H13.0291C13.0763 7.71883 13.127 7.71476 13.1798 7.70671C13.7079 7.62646 13.6914 7.14432 13.6834 6.91267C13.6812 6.84743 13.679 6.78571 13.6845 6.74467C13.686 6.73433 13.6868 6.72395 13.6868 6.71356Z"
              fill="white"
            />
            <path
              d="M8.74919 1.27642C8.81255 1.28099 8.87252 1.28537 8.92246 1.29302C12.435 1.83319 14.0503 3.49739 14.498 7.03737C14.5056 7.09754 14.5068 7.17093 14.508 7.24865C14.5125 7.52522 14.5217 8.10057 15.1396 8.1125L15.1587 8.1127C15.3525 8.1127 15.5067 8.05426 15.6169 7.93888C15.8093 7.73769 15.7959 7.43881 15.785 7.19861C15.7824 7.13968 15.7799 7.08417 15.7805 7.03558C15.8252 3.41511 12.6913 0.132075 9.07401 0.00998758C9.05901 0.00949068 9.0447 0.0102857 9.03024 0.012323C9.02313 0.0133665 9.00996 0.0146584 8.9874 0.0146584C8.95133 0.0146584 8.90696 0.0115279 8.8599 0.00834783C8.80301 0.00447205 8.73851 0 8.67312 0C8.09707 0 7.98755 0.409441 7.97354 0.653516C7.94124 1.21759 8.48693 1.25729 8.74919 1.27642Z"
              fill="white"
            />
            <path
              d="M14.3285 11.6132C14.2538 11.5561 14.1766 11.4971 14.1043 11.4388C13.7208 11.1302 13.3128 10.8458 12.9182 10.5706C12.8364 10.5136 12.7545 10.4565 12.6729 10.3992C12.1674 10.0442 11.713 9.87169 11.2837 9.87169C10.7055 9.87169 10.2013 10.1912 9.78523 10.8212C9.60088 11.1005 9.37723 11.2363 9.1016 11.2363C8.93862 11.2363 8.75342 11.1898 8.55124 11.098C6.91979 10.3582 5.75482 9.22389 5.08863 7.7266C4.76659 7.00292 4.87099 6.52988 5.43775 6.14488C5.75959 5.92645 6.35864 5.51979 6.31621 4.74106C6.26816 3.85673 4.31695 1.19591 3.49484 0.893701C3.14677 0.765701 2.78105 0.764509 2.4059 0.89072C1.4608 1.20843 0.782593 1.7664 0.444407 2.50419C0.117599 3.21708 0.132357 4.05415 0.48709 4.92491C1.51258 7.44247 2.95437 9.63745 4.77256 11.4488C6.55223 13.2219 8.73961 14.6743 11.2739 15.7656C11.5023 15.8638 11.7419 15.9175 11.9169 15.9566C11.9765 15.97 12.028 15.9814 12.0655 15.9917C12.0861 15.9973 12.1074 16.0003 12.1287 16.0005L12.1487 16.0006C12.1487 16.0006 12.1487 16.0006 12.1488 16.0006C13.3408 16.0006 14.772 14.9114 15.2115 13.6697C15.5966 12.5824 14.8935 12.045 14.3285 11.6132Z"
              fill="white"
            />
            <path
              d="M9.27641 4.15278C9.07233 4.15795 8.64763 4.16848 8.49862 4.60103C8.4289 4.80316 8.43725 4.97867 8.52346 5.12267C8.64997 5.33395 8.89236 5.39869 9.11283 5.43422C9.91238 5.56252 10.323 6.00465 10.4052 6.82552C10.4433 7.20828 10.7011 7.47556 11.032 7.47556C11.0564 7.47556 11.0815 7.47412 11.1064 7.47109C11.5044 7.42374 11.6973 7.13131 11.6799 6.60202C11.6862 6.04962 11.3972 5.42249 10.9055 4.92296C10.4121 4.4219 9.81737 4.13971 9.27641 4.15278Z"
              fill="white"
            />
          </svg>
        </div>
        {{ headerData.mobile_number || "+91-626 611 7944" }}
      </div>
      <a
        [href]="
          addHttpsIfMissing(
            headerData?.whatsapp_URL?.trim() ||
              'https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ'
          )
        "
        target="_blank"
        class="text_decoration_none cursor-pointer"
      >
        <div class="header_menu_bottom_item">
          <div class="header_menu_bottom_item_icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0,0,255.98958,255.98958"
              width="25px"
              height="25px"
              fill-rule="none"
            >
              <g
                fill="none"
                fill-rule="none"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <g transform="scale(5.33333,5.33333)">
                  <path
                    d="M4.868,43.303l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98c-0.001,0 0,0 0,0h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311z"
                    fill="#ffffff"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M4.868,43.803c-0.132,0 -0.26,-0.052 -0.355,-0.148c-0.125,-0.127 -0.174,-0.312 -0.127,-0.483l2.639,-9.636c-1.636,-2.906 -2.499,-6.206 -2.497,-9.556c0.004,-10.742 8.745,-19.48 19.486,-19.48c5.21,0.002 10.105,2.031 13.784,5.713c3.679,3.683 5.704,8.577 5.702,13.781c-0.004,10.741 -8.746,19.48 -19.486,19.48c-3.189,-0.001 -6.344,-0.788 -9.144,-2.277l-9.875,2.589c-0.042,0.012 -0.084,0.017 -0.127,0.017z"
                    fill="#ffffff"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M24.014,5c5.079,0.002 9.845,1.979 13.43,5.566c3.584,3.588 5.558,8.356 5.556,13.428c-0.004,10.465 -8.522,18.98 -18.986,18.98h-0.008c-3.177,-0.001 -6.3,-0.798 -9.073,-2.311l-10.065,2.64l2.694,-9.835c-1.662,-2.878 -2.536,-6.144 -2.535,-9.489c0.005,-10.465 8.521,-18.979 18.987,-18.979M24.014,42.974v0v0M24.014,42.974v0v0M24.014,4v0c-11.016,0 -19.982,8.962 -19.987,19.979c-0.001,3.367 0.849,6.685 2.461,9.622l-2.585,9.439c-0.094,0.345 0.002,0.713 0.254,0.967c0.19,0.192 0.447,0.297 0.711,0.297c0.085,0 0.17,-0.011 0.254,-0.033l9.687,-2.54c2.828,1.468 5.998,2.243 9.197,2.244c11.024,0 19.99,-8.963 19.995,-19.98c0.002,-5.339 -2.075,-10.359 -5.848,-14.135c-3.775,-3.777 -8.796,-5.858 -14.139,-5.86z"
                    fill="#25D366"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M35.176,12.832c-2.98,-2.982 -6.941,-4.625 -11.157,-4.626c-8.704,0 -15.783,7.076 -15.787,15.774c-0.001,2.981 0.833,5.883 2.413,8.396l0.376,0.597l-1.595,5.821l5.973,-1.566l0.577,0.342c2.422,1.438 5.2,2.198 8.032,2.199h0.006c8.698,0 15.777,-7.077 15.78,-15.776c0.001,-4.215 -1.638,-8.179 -4.618,-11.161z"
                    fill="#25D366"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M19.268,16.045c-0.355,-0.79 -0.729,-0.806 -1.068,-0.82c-0.277,-0.012 -0.593,-0.011 -0.909,-0.011c-0.316,0 -0.83,0.119 -1.265,0.594c-0.435,0.475 -1.661,1.622 -1.661,3.956c0,2.334 1.7,4.59 1.937,4.906c0.237,0.316 3.282,5.259 8.104,7.161c4.007,1.58 4.823,1.266 5.693,1.187c0.87,-0.079 2.807,-1.147 3.202,-2.255c0.395,-1.108 0.395,-2.057 0.277,-2.255c-0.119,-0.198 -0.435,-0.316 -0.909,-0.554c-0.474,-0.238 -2.807,-1.385 -3.242,-1.543c-0.435,-0.158 -0.751,-0.237 -1.068,0.238c-0.316,0.474 -1.225,1.543 -1.502,1.859c-0.277,0.317 -0.554,0.357 -1.028,0.119c-0.474,-0.238 -2.002,-0.738 -3.815,-2.354c-1.41,-1.257 -2.362,-2.81 -2.639,-3.285c-0.277,-0.474 -0.03,-0.731 0.208,-0.968c0.213,-0.213 0.474,-0.554 0.712,-0.831c0.237,-0.277 0.316,-0.475 0.474,-0.791c0.158,-0.317 0.079,-0.594 -0.04,-0.831c-0.117,-0.238 -1.039,-2.584 -1.461,-3.522z"
                    fill="#ffffff"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
          Subscribe for Latest News & Update
        </div>
      </a>
      <div class="header_menu_bottom_item">
        <div
          class="header_top_left_box1_item border_right_black cursor-pointer"
        >
          <div class="header_top_left_box1_item_icon1">
            <!-- Dropdown toggle -->
            <div
              class="selected-option text_black_5 d-flex align-items-center"
              (click)="toggleDropdown()"
            >
              <span>{{ selectedBrochure?.fileName || "Brochures" }}</span>
              <div class="p-x-5">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.160635 1.126L3.99992 5.76188C4.0618 5.83657 4.13857 5.89652 4.22495 5.93762C4.31133 5.97872 4.40528 6 4.50036 6C4.59544 6 4.68939 5.97872 4.77577 5.93762C4.86215 5.89652 4.93892 5.83657 5.0008 5.76188L8.84009 1.126C9.20649 0.683502 8.90271 0 8.33965 0H0.659978C0.0969123 0 -0.206869 0.683502 0.160635 1.126Z"
                    fill="#303030"
                  />
                </svg>
              </div>
            </div>

            <!-- Dropdown options, shown when 'dropdownOpen' is true -->
            <div class="header_top_left_box1_item_icon1_dropdown">
              <div
                class="options header_top_left_box1_item_icon1_dropdown_content"
                *ngIf="dropdownOpen"
              >
                <ul
                  class="header_top_left_box1_item_icon1_dropdown_content_box p-x-10 text_blue_3 bg_1"
                >
                  <li
                    *ngFor="let brochure of brochures"
                    (click)="selectBrochure(brochure)"
                    class="header_top_right_body_dropdown_content_box_item cursor-pointer padding-6-6 text_blue_3 d-flex align-items-center bottom-border-1"
                  >
                    <div class="d-flex align-items-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-r-5"
                      >
                        <g clip-path="url(#clip0_1891_104)">
                          <path
                            d="M12.3667 2.24438L14.2476 2.24805L12.3667 0.404785V2.24438Z"
                            fill="#0032A0"
                          />
                          <path
                            d="M11.8916 3.19189C11.63 3.19141 11.4183 2.97925 11.4183 2.71765V0H3.50061C3.23865 0 3.02637 0.21228 3.02637 0.474243V8.92627C3.52002 8.72009 4.0614 8.60596 4.62903 8.60596C4.90942 8.60596 5.18335 8.63391 5.44836 8.68689C5.41663 8.62341 5.39844 8.55188 5.39844 8.47595C5.39844 8.21411 5.61072 8.00183 5.87256 8.00183H11.5842C11.8461 8.00183 12.0585 8.21411 12.0585 8.47595C12.0585 8.73792 11.8461 8.9502 11.5842 8.9502H6.2876C7.76477 9.5929 8.80029 11.0663 8.80029 12.7772C8.80029 13.4414 8.64404 14.0696 8.3667 14.6276H14.1428C14.4048 14.6276 14.6171 14.4153 14.6171 14.1533V3.19727L11.8916 3.19189ZM9.87695 4.74536C9.87695 5.00732 9.66467 5.2196 9.40283 5.2196H5.87256C5.61072 5.2196 5.39844 5.00732 5.39844 4.74536C5.39844 4.48352 5.61072 4.27112 5.87256 4.27112H9.40283C9.66467 4.27112 9.87695 4.4834 9.87695 4.74536ZM11.5842 7.08496H5.87256C5.61072 7.08496 5.39844 6.87256 5.39844 6.61072C5.39844 6.34875 5.61072 6.13647 5.87256 6.13647H11.5842C11.8461 6.13647 12.0585 6.34875 12.0585 6.61072C12.0585 6.87256 11.8462 7.08496 11.5842 7.08496Z"
                            fill="#0032A0"
                          />
                          <path
                            d="M7.85193 12.7772C7.85193 11.0001 6.40613 9.55444 4.62903 9.55444C2.85205 9.55444 1.40625 11.0001 1.40625 12.7772C1.40625 14.5543 2.85205 16 4.62903 16C6.40613 16 7.85193 14.5542 7.85193 12.7772ZM6.15149 13.4755L4.90503 14.3673C4.82239 14.4264 4.72571 14.4558 4.62903 14.4558C4.52942 14.4558 4.42981 14.4244 4.34583 14.3619L3.14856 13.4701C2.93848 13.3136 2.89514 13.0165 3.05151 12.8065C3.20801 12.5964 3.50513 12.553 3.71521 12.7095L4.15491 13.037V11.5267C4.15491 11.2649 4.36719 11.0526 4.62903 11.0526C4.89099 11.0526 5.10327 11.2649 5.10327 11.5267V13.0592L5.59949 12.7041C5.8125 12.5518 6.10876 12.6008 6.26111 12.8138C6.41357 13.0269 6.36438 13.323 6.15149 13.4755Z"
                            fill="#0032A0"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1891_104">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span class="p-r-10">{{ brochure.fileName }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Sign In Form -->
<div
  class="modal fade bg_4"
  id="sign-in"
  aria-labelledby="sign_in"
  aria-hidden="true"
>
  <div class="modal-dialog text-center modal-dialog-centered">
    <div class="modal-content p-x-15 bg_1">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="dis-block-2">
        <div class="dis-flex-1">
          <div class="header_bottom_logo">
            <img
              class="header_bottom_logo_img"
              src="../../../assets/img/logo.png"
              alt="Logo"
            />
          </div>
        </div>
        <div class="p-top-32">
          <span class="text_blue_9">Sign In</span>
        </div>
      </div>
      <div class="modal-body login">
        <form [formGroup]="signInForm" (ngSubmit)="submit_signin_form()">
          <div class="mb-3">
            <label for="username" class="form-label dis-flex-4 text_grey_2"
              >Email ID / User ID</label
            >
            <input
              id="username"
              formControlName="username"
              type="text"
              class="form-control"
              placeholder="Enter Email ID / User ID"
            />
            <div
              class="text_align"
              *ngIf="
                signInForm.controls['username']?.invalid &&
                signInForm.controls['username']?.touched
              "
            >
              <small
                *ngIf="signInForm.controls['username']?.errors?.['required']"
                class="color_red weight_500 font_13"
                >Username is required.</small
              >
              <small
                *ngIf="signInForm.controls['username']?.errors?.['email']"
                class="color_red weight_500 font_13"
                >Invalid email format.</small
              >
            </div>
          </div>
          <div class="mb-3 position-relative">
            <label for="password" class="form-label dis-flex-4 text_grey_2"
              >Password</label
            >
            <input
              id="password"
              formControlName="password"
              [type]="password"
              class="form-control"
              placeholder="Enter Password"
            />
            <div
              class="eyeIcons position-absolute bottom-0 end-0 me-2"
              style="margin-bottom: 8px"
              (click)="togglePassword()"
            >
              <img
                src="../../../assets/icons/eye-open.svg"
                alt="Show password"
                *ngIf="!show"
              />
              <img
                src="../../../assets/icons/eye-close.svg"
                alt="Hide password"
                *ngIf="show"
              />
            </div>
            <div
              class="text_align"
              *ngIf="
                signInForm.controls['password']?.invalid &&
                signInForm.controls['password']?.touched
              "
            >
              <small
                *ngIf="signInForm.controls['password']?.errors?.['required']"
                class="color_red weight_500 font_13"
                >Password is required.</small
              >
            </div>
            <div
              *ngIf="errorMessage"
              class="error-message color_red weight_500 font_13 text_align"
            >
              {{ errorMessage }}
            </div>
          </div>
          <div class="text_align-right p-b-30">
            <span
              class="text_blue_14 cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#forgot-password"
              data-dismiss="modal"
              (click)="closeSigninModel()"
              >Forgot password?</span
            >
          </div>
          <button type="submit" class="button_blue_6 text_white_1 w-100">
            Submit
          </button>
        </form>
        <div class="p-top-30">
          <p class="text_black_13">
            Don’t have an account?
            <span
              class="text_blue_14 cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#sign-up"
              data-bs-dismiss="modal"
              >Sign Up</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Forgot password model -->
<div
  class="modal fade bg_4"
  id="forgot-password"
  aria-labelledby="forgot_password"
  aria-hidden="true"
>
  <div class="modal-dialog text-center modal-dialog-centered">
    <div class="modal-content p-x-15 bg_1">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="dis-block-2">
        <div class="dis-flex-1">
          <div class="header_bottom_logo">
            <img
              class="header_bottom_logo_img"
              src="../../../assets/img/logo.png"
              alt="Logo"
            />
          </div>
        </div>
        <div class="p-top-32">
          <span class="text_blue_9">Forgot Password</span>
        </div>
      </div>
      <div class="modal-body">
        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="submitForgotPasswordForm()"
        >
          <div class="mb-3">
            <label for="email" class="form-label dis-flex-4 text_grey_2"
              >Email Address</label
            >
            <input
              id="email"
              formControlName="email"
              type="email"
              class="form-control text_grey_3"
              placeholder="Enter your email"
            />
            <div
              class="text_align"
              *ngIf="
                forgotPasswordForm.controls['email']?.invalid &&
                forgotPasswordForm.controls['email']?.touched
              "
            >
              <small
                *ngIf="forgotPasswordForm.controls['email']?.errors?.['required']"
                class="text-red-1"
                >Email address is required.</small
              >
              <small
                *ngIf="forgotPasswordForm.controls['email']?.errors?.['email']"
                class="text-red-1"
                >Invalid email format.</small
              >
            </div>
          </div>
          <div>
            <div class="m-t-20 m-b-16">
              <re-captcha
                class="m-t-20"
                [siteKey]="recaptchaSiteKey"
                (resolved)="onCaptchaSuccess($event)"
              >
              </re-captcha>
              <div *ngIf="formSubmitted && !recaptchaResponse">
                <small class="text-red-1">Please complete the reCAPTCHA.</small>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="button_blue_6 text_white_1 w-100 p-top-10"
          >
            Submit
          </button>
          <div *ngIf="errorMessage" class="error-message text-red-1 text_align">
            {{ errorMessageforgot }}
          </div>
          <div
            *ngIf="successMessage"
            class="success-message text-green-1 text_align"
          >
            {{ successMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="alertModelforgot"
  tabindex="-1"
  aria-labelledby="alertModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="alert alert-success alert-dismissible fade show text-align-center"
          role="alert"
        >
          The email has been sent to you at <strong>{{ sentEmail }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- alert model -->
<div
  class="modal fade"
  id="alertModel"
  tabindex="-1"
  aria-labelledby="alertModelLabel"
  aria-hidden="true"
  #alertModal
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="alert alert-success alert-dismissible fade show text_align-center"
          role="alert"
        >
          <strong>Success!</strong> Thank you for your demo request. The
          ChemRobotics team will reach out to you shortly.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Demo request -->
<div
  class="demo_request modal fade bg_4"
  id="demo-form"
  aria-labelledby="demo_request"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content p-x-20 bg_1 w-100">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="p-x-20">
        <div class="dis-grid-1 demo_request_head">
          <div class="header_bottom_logo">
            <img
              class="header_bottom_logo_img"
              src="../../../assets/img/logo.png"
              alt="Logo"
            />
          </div>
          <div class="dis-flex-2">
            <span class="text_blue_9">Request a Demo</span>
          </div>
          <div class="dialog_body_patent">
            <div class="dialog_body_patent_items">
              <ng-container>
                <p class="text_black_13 text-end" style="margin-top: 20px">
                  View page in full screen -
                  <a
                    href="https://www.chemrobotics.com/demo_request"
                    class="text_blue_17 cursor-pointer"
                    target="_blank"
                    style="text-decoration: none; color: #0032a0"
                    >Demo Request</a
                  >
                  <button
                    type="button"
                    class="btn btn-info m-1 dialog_body_patent_items_btn"
                    (click)="copyToClipboarddemo()"
                    style="background-color: white; border: 1px solid #0032a0"
                  >
                    <img
                      src="../../../assets/icons/copy_icon.png"
                      alt="Copy icon"
                      width="20px"
                    />
                  </button>
                </p>
              </ng-container>
            </div>
            <div
              class="position-fixed top-0 end-0 p-3"
              style="z-index: 11; margin-top: 10px"
            >
              <div
                id="copyToast"
                #copyToast
                class="toast hide"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                style="
                  background-color: #e3f2fd;
                  color: #333;
                  border-radius: 0.25rem;
                "
              >
                <div class="toast-body" [innerHTML]="copyMessage"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-top-20">
          <div class="dis-flex-4 p-x-15">
            <div>
              <span class="text_black_14"
                >Choose Below Verticals For Demo:-</span
              >
            </div>
            <div class="selected-count flex-1" *ngIf="selectedCountdemo > 0">
              {{ selectedCountdemo }} selected
            </div>
            <div class="selected-count flex-1" *ngIf="selectedCountdemo === 0">
              0 selected
            </div>
          </div>
        </div>
        <div>
          <form
            class=""
            [formGroup]="demorequestForm"
            (ngSubmit)="submit_demo_form()"
          >
            <div class="dis-flex-7 flex-wrap p-top-24 demo_request_checkbox">
              <ng-container *ngFor="let vertical of verticals; let i = index">
                <div
                  class="p-x-25 p-y-11 dis-flex-4 border_blue_1 border-radius-22 m-r-16 m-b-16"
                  [ngClass]="{
                    bg_1: !vertical.checked,
                    bg_3: vertical.checked,
                    text_blue_5: !vertical.checked,
                    text_white_9: vertical.checked
                  }"
                >
                  <input
                    type="checkbox"
                    id="checkbox{{ i }}"
                    name="checkbox{{ i }}"
                    (change)="toggleVerticalChecked(i)"
                    [checked]="vertical.checked"
                  />
                  <label for="checkbox{{ i }}" class="p-l-10">{{
                    vertical.vertical
                  }}</label>
                </div>
              </ng-container>
            </div>
            <div class="demo_request_form">
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="demoDate1" class="dis-flex-4 text_grey_2"
                  >Demo Date*</label
                >
                <input
                  type="date"
                  id="demoDate"
                  formControlName="date"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Select Demo Date"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('date')?.touched &&
                    demorequestForm.get('date')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('date')?.errors?.['required']"
                    >Date is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="demoTime" class="dis-flex-4 text_grey_2"
                  >Demo Time*</label
                >
                <input
                  type="time"
                  id="demoTime"
                  formControlName="time"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Select Demo Time"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('time')?.touched &&
                    demorequestForm.get('time')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('time')?.errors?.['required']"
                    >Time is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="name" class="dis-flex-4 text_grey_2"
                  >“First Name*</label
                >
                <input
                  type="text"
                  formControlName="fname"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter First Name"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('fname')?.touched &&
                    demorequestForm.get('fname')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('fname')?.errors?.['required']"
                    >first name is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="name" class="dis-flex-4 text_grey_2"
                  >Last Name*</label
                >
                <input
                  type="text"
                  formControlName="lname"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Last Name"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('lname')?.touched &&
                    demorequestForm.get('lname')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('lname')?.errors?.['required']"
                    >last name is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="email" class="dis-flex-4 text_grey_2"
                  >Business email*</label
                >
                <input
                  type="email"
                  formControlName="email"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Business email"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('email')?.touched &&
                    demorequestForm.get('email')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('email')?.errors?.['required']"
                    >Email is required.</span
                  >
                  <span *ngIf="demorequestForm.get('email')?.errors?.['email']"
                    >Invalid email format.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label class="text_grey_2">Phone*</label>
                <div class="width-100-per">
                  <select
                    id="countryCode"
                    formControlName="country_code"
                    class="text_grey_3 height-40 border-radius-4 p-x-10 width-25-per"
                  >
                    <option
                      *ngFor="let country of countries"
                      [value]="country.code"
                    >
                      <img
                        [src]="country.flag"
                        alt="{{ country.name }}"
                        width="16"
                        height="12"
                        style="margin-right: 8px"
                      />
                      {{ country.code }}
                    </option>
                  </select>
                  <input
                    type="tel"
                    name="phone"
                    class="text_grey_3 height-40 border-radius-4 p-x-15 width-75-per"
                    placeholder="626 611 7944"
                    formControlName="phone"
                  />
                </div>
                <div
                  *ngIf="
                    demorequestForm.get('phone')?.touched &&
                    demorequestForm.get('phone')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('phone')?.errors?.['required']"
                    >Phone number is required.</span
                  >
                  <span
                    *ngIf="demorequestForm.get('phone')?.errors?.['pattern']"
                    >Phone number must be 10 digits.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="jobTitle" class="dis-flex-4 text_grey_2"
                  >Job title*</label
                >
                <input
                  type="text"
                  formControlName="job"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Job Title"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('job')?.touched &&
                    demorequestForm.get('job')?.invalid
                  "
                  class="text-red-1"
                >
                  <span *ngIf="demorequestForm.get('job')?.errors?.['required']"
                    >Job is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="company" class="dis-flex-4 text_grey_2"
                  >Company*</label
                >
                <input
                  type="text"
                  formControlName="company"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Company"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('company')?.touched &&
                    demorequestForm.get('company')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('company')?.errors?.['required']"
                    >company is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="country" class="dis-flex-4 text_grey_2"
                  >Country*</label
                >
                <input
                  type="text"
                  id="country"
                  formControlName="country"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Country"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('country')?.touched &&
                    demorequestForm.get('country')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('country')?.errors?.['required']"
                    >Country is required.</span
                  >
                </div>
              </div>
              <div class="dis-block-1 p-top-18 p-x-15">
                <label for="industry" class="dis-flex-4 text_grey_2"
                  >Industry*</label
                >
                <input
                  type="text"
                  id="industry"
                  formControlName="industry"
                  class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                  placeholder="Enter Industry"
                  required
                />
                <div
                  *ngIf="
                    demorequestForm.get('industry')?.touched &&
                    demorequestForm.get('industry')?.invalid
                  "
                  class="text-red-1"
                >
                  <span
                    *ngIf="demorequestForm.get('industry')?.errors?.['required']"
                    >Industry is required.</span
                  >
                </div>
              </div>
            </div>
            <div class="p-top-18 p-x-15">
              <div>
                <span class="text_grey_2">
                  How did you hear about Chemrobotics?</span
                >
              </div>
              <div class="dis-flex-7 flex-wrap p-top-12">
                <div class="m-r-16 p-x-15">
                  <label>
                    <input type="checkbox" name="source" value="internet" />
                    Word of Mouth
                  </label>
                </div>
                <div class="m-r-16 p-x-15">
                  <label>
                    <input type="checkbox" name="source" value="friend" /> Add
                    in magzine
                  </label>
                </div>
                <div class="m-r-16 p-x-15">
                  <label>
                    <input
                      type="checkbox"
                      name="source"
                      value="advertisement"
                    />
                    Google Ad
                  </label>
                </div>
                <div class="m-r-16 p-x-15">
                  <label>
                    <input type="checkbox" name="source" value="social_media" />
                    Linkdin
                  </label>
                </div>
                <div class="m-r-16 p-x-15">
                  <label>
                    <input type="checkbox" name="source" value="event" /> Email
                  </label>
                </div>
                <div class="p-x-15">
                  <label>
                    <input type="checkbox" name="source" value="other" /> Others
                  </label>
                </div>
              </div>
            </div>

            <div class="dis-block-1 p-top-18 p-x-15">
              <label for="comment" class="dis-flex-4 text_grey_2"
                >Comment</label
              >
              <textarea
                id="comment"
                formControlName="comment"
                rows="3"
                class="dis-flex-4 text_grey_3 border-radius-4 width-100-per p-x-15"
                placeholder="Write your comment here..."
              ></textarea>
            </div>
            <div class="p-top-10 p-b-20 p-x-0 demo_request_bottom">
              <div>
                <div
                  class="g-recaptcha m-t-20 p-x-15"
                  data-sitekey="your_site_key"
                ></div>
              </div>
              <div class="demo_request_bottom_submit">
                <button type="submit" class="button_blue_4 text_white_1">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Sign Up Form -->
<div
  class="sign_up modal fade bg_4"
  id="sign-up"
  tabindex="-1"
  aria-labelledby="sign_up"
  aria-hidden="true"
>
  <div
    class="sign_up_modal modal-dialog modal-xl text-center modal-dialog-centered"
  >
    <div class="modal-content p-x-20 bg_1 w-100">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="dis-grid-1">
        <div class="header_bottom_logo">
          <img
            class="header_bottom_logo_img"
            src="../../../assets/img/logo.png"
            alt="Logo"
          />
        </div>
        <div class="dis-flex-2">
          <span class="text_blue_9">Sign Up</span>
        </div>
        <div class="p-top-30" style="margin-left: 80px">
          <p class="text_black_13">
            Already have an account?
            <span
              class="text_blue_17 cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#sign-in"
              data-bs-dismiss="modal"
              style="color: #0032a0"
              >Sign In</span
            >
          </p>
          <p class="text_black_13">
            View page in full screen -
            <a
              href="https://www.chemrobotics.com/registration"
              class="text_blue_17 cursor-pointer"
              target="_blank"
              style="text-decoration: none; color: #0032a0"
              >Sign Up</a
            >
            <button
              type="button"
              class="btn btn-info m-1 dialog_body_patent_items_btn"
              (click)="copyToClipboardsignup()"
              style="background-color: white; border: 1px solid #0032a0"
            >
              <img
                src="../../../assets/icons/copy_icon.png"
                alt="Copy icon"
                width="20px"
              />
            </button>
          </p>
        </div>
        <div class="position-fixed top-0 end-0 p-3" style="z-index: 11">
          <div
            id="copyToast1"
            #copyToast1
            class="toast hide"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style="
              background-color: #e3f2fd;
              color: #333;
              border-radius: 0.25rem;
              padding-top: 10px;
              padding-bottom: 10px;
            "
          >
            <div class="toast-body1" [innerHTML]="copyMessage"></div>
          </div>
        </div>
      </div>
      <div class="sign_up_modal_list dis-flex-1 p-top-20">
        <ng-container *ngFor="let detail of details">
          <div class="sign_up_modal_list_item width_33">
            <div class="sign_up_modal_list_item_grid">
              <div class="p-top-13_5">
                <div class="hl_1"></div>
              </div>
              <div>
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="8.5"
                    cy="8.5"
                    r="6"
                    fill="white"
                    stroke="#0032A0"
                    stroke-width="5"
                  ></circle>
                </svg>
                <div class="height-20 dis-flex-1">
                  <div class="vl_1 height-100-per"></div>
                </div>
              </div>
              <div class="p-top-13_5">
                <div class="hl_1"></div>
              </div>
            </div>
            <div class="p-top-12">
              <span class="text_blue_15">{{ detail }}</span>
            </div>
          </div>
        </ng-container>
      </div>
      <form [formGroup]="signUpForm" (ngSubmit)="submit_signup_form()">
        <div
          class="sign_up_modal_body modal-body"
          *ngIf="!showSecondForm && !showThirdForm"
        >
          <div>
            <div class="dis-flex-4">
              <div>
                <span class="text_black_14"
                  >I am a Professional and describe myself as:</span
                >
              </div>
              <div class="selected-count flex-1">
                {{ selectedCountsignup || "0" }} selected
              </div>
            </div>
            <div class="">
              <div class="dis-flex-7 flex-wrap p-top-24">
                <ng-container *ngFor="let label of labels; let i = index">
                  <div
                    class="p-x-25 p-y-11 dis-flex-4 border_blue_1 border-radius-22 m-r-16 m-b-16 bg_1"
                    [ngClass]="{
                      bg_3: label.checked,
                      'text_white_9 ': label.checked
                    }"
                  >
                    <input
                      type="checkbox"
                      id="checkbox{{ i }}"
                      name="checkbox{{ i }}"
                      (change)="toggleCheckbox(i)"
                      [checked]="label.checked"
                    />
                    <label
                      for="checkbox{{ i }}"
                      class="text_blue_5 p-l-10"
                      [ngClass]="{ text_white_9: label.checked }"
                      >{{ label.profession }}</label
                    >
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="text_align">
              <div class="">
                <p class="text_black_14">Note:</p>
              </div>
              <div class="sign_up_modal_body_note">
                <ul class="sign_up_modal_body_note_list">
                  <li
                    class="sign_up_modal_body_note_list_item text_black_5 p-top-8"
                    *ngFor="let list of lists; let i = index"
                  >
                    <div>
                      <div
                        class="width-18 height-18 bg_3 border-radius-50-per text_white_15 dis-flex-2"
                      >
                        {{ i + 1 }}
                      </div>
                    </div>
                    <div [innerHTML]="list"></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="dis-flex-5 p-top-20 p-b-20 p-x-40">
            <button
              class="button_blue_4 text_white_1"
              [ngClass]="{ opacity: selectedCountsignup === 0 }"
              [disabled]="!isNextButtonEnabled()"
              (click)="toggleSecondForm()"
            >
              Next
            </button>
          </div>
        </div>
        <div
          class="sign_up_modal_body"
          *ngIf="showSecondForm && !showThirdForm"
        >
          <div class="sign_up_modal_body_form2">
            <div class="">
              <div class="sign_up_modal_body_form2_box1 dis-grid-2">
                <div class="p-top-18 p-x-20">
                  <label for="affiliation" class="dis-flex-4 text_grey_2"
                    >Institute/Company Affiliation
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="affiliation"
                    formControlName="institute_company"
                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                    placeholder="Enter Institute/Company Affiliation"
                    required
                  />
                  <div
                    *ngIf="
                      isSubmitted &&
                      signUpForm.controls['institute_company'].invalid
                    "
                    class="text-start"
                  >
                    <small
                      class="text-red-1"
                      *ngIf="signUpForm.controls['institute_company'].errors?.['required']"
                      >Institute/Company Affiliation is required</small
                    >
                  </div>
                </div>
                <div class="p-top-18 p-x-20">
                  <label for="department" class="dis-flex-4 text_grey_2"
                    >Name of Department/ Business Verticals<span
                      class="text-danger"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    id="department"
                    formControlName="department_name"
                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                    placeholder="Enter Name of Department/ Business Verticals"
                    required
                  />
                  <div
                    *ngIf="
                      isSubmitted &&
                      signUpForm.controls['department_name'].invalid
                    "
                    class="text-start"
                  >
                    <small
                      class="text-red-1 text_align"
                      *ngIf="signUpForm.controls['department_name'].errors?.['required']"
                      >Name of Department/ Business Verticals is required</small
                    >
                  </div>
                </div>
                <div class="p-top-18 p-x-20">
                  <label for="industry" class="dis-flex-4 text_grey_2"
                    >Industry<span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    id="industry"
                    required
                    formControlName="industry"
                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                    placeholder="Enter Industry"
                    required
                  />
                  <div
                    *ngIf="
                      isSubmitted && signUpForm.controls['industry'].invalid
                    "
                    class="text-start"
                  >
                    <small
                      class="text-red-1 text_align"
                      *ngIf="signUpForm.controls['industry'].errors?.['required']"
                      >Industry is required</small
                    >
                  </div>
                </div>
                <div class="p-top-18 p-x-20">
                  <label for="companyName" class="dis-flex-4 text_grey_2"
                    >Company Name<span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    id="companyName"
                    formControlName="company_name"
                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                    placeholder="Enter Company Name"
                    required
                  />
                  <div
                    *ngIf="
                      isSubmitted && signUpForm.controls['company_name'].invalid
                    "
                    class="text-start"
                  >
                    <small
                      class="text-red-1 text_align"
                      *ngIf="signUpForm.controls['company_name'].errors?.['required']"
                      >Company Name is required</small
                    >
                  </div>
                </div>
                <div class="p-top-18 p-x-20">
                  <label for="occupation" class="dis-flex-4 text_grey_2"
                    >Occupation<span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    id="occupation"
                    formControlName="occupation"
                    class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                    placeholder="Enter Occupation"
                    required
                  />
                  <div
                    *ngIf="
                      isSubmitted && signUpForm.controls['occupation'].invalid
                    "
                    class="text-start"
                  >
                    <small
                      class="text-red-1 text_align"
                      *ngIf="signUpForm.controls['occupation'].errors?.['required']"
                      >Occupation is required</small
                    >
                  </div>
                </div>
              </div>
              <div>
                <div class="text_align p-top-18 p-x-20">
                  <span class="text_black_14">Company Address</span>
                </div>
                <div class="dis-grid-2 sign_up_modal_body_form2_box2">
                  <div class="p-top-18 p-x-20">
                    <label for="country" class="dis-flex-4 text_grey_2"
                      >Country<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="country"
                      formControlName="country_name"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Select Country"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted &&
                        signUpForm.controls['country_name'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['country_name'].errors?.['required']"
                        >Country is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="state" class="dis-flex-4 text_grey_2"
                      >State<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="state"
                      formControlName="state"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter State"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['state'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['state'].errors?.['required']"
                        >State is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="addressLine" class="dis-flex-4 text_grey_2"
                      >Address<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="addressLine"
                      formControlName="address"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Address Line"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['address'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['address'].errors?.['required']"
                        >Address is required</small
                      >
                    </div>
                  </div>
                  <div class="p-top-18 p-x-20">
                    <label for="pinCode" class="dis-flex-4 text_grey_2"
                      >PIN Code<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="pinCode"
                      formControlName="pincode"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="PIN Code"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['pincode'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['pincode'].errors?.['required']"
                        >PIN Code is required</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-top-20 p-b-20 p-x-40 sign_up_modal_body_button1">
            <div class="sign_up_modal_body_button1_one">
              <button
                class="text_blue_4 button_white_3"
                (click)="toggleSecondForm()"
              >
                Previous
              </button>
            </div>
            <div class="sign_up_modal_body_button1_two">
              <button
                class="button_blue_4 text_white_1"
                (click)="toggleThirdForm()"
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <div class="sign_up_modal_body" *ngIf="showThirdForm">
          <div class="">
            <div class="sign_up_modal_body_form3">
              <div class="sign_up_modal_body_form3_boxes">
                <div class="p-x-20 dis-flex-7 p-top-18">
                  <div>
                    <label class="text_grey_2"
                      >Gender<span class="text-danger">*</span> :</label
                    >
                  </div>
                  <div class="dis-flex-7">
                    <div class="p-x-20">
                      <label class="text_black_13">
                        <input
                          type="radio"
                          formControlName="gender"
                          value="male"
                        />
                        Male
                      </label>
                    </div>
                    <div class="p-x-20">
                      <label class="text_black_13">
                        <input
                          type="radio"
                          formControlName="gender"
                          value="female"
                        />
                        Female
                      </label>
                    </div>
                    <div class="p-x-20">
                      <label class="text_black_13">
                        <input
                          type="radio"
                          formControlName="gender"
                          value="other"
                        />
                        Other
                      </label>
                    </div>
                  </div>
                  <div
                    *ngIf="isSubmitted && signUpForm.controls['gender'].invalid"
                  >
                    <small
                      class="text-red-1 text_align"
                      *ngIf="signUpForm.controls['gender'].errors?.['required']"
                      >Select atleast one</small
                    >
                  </div>
                </div>

                <div
                  class="dis-grid-3 width-100-per sign_up_modal_body_form3_boxes_box1"
                >
                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="title" class="dis-flex-4 text_grey_2"
                      >Title<span class="text-danger">*</span></label
                    >
                    <select
                      id="title"
                      formControlName="prefix"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      required
                    >
                      <option value="" disabled selected>Select Title</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                      <option value="Dr">Dr</option>
                      <option value="Prof">Prof</option>
                      <!-- Add more options as needed -->
                    </select>
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['prefix'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['prefix'].errors?.['required']"
                        >Title is required</small
                      >
                    </div>
                  </div>

                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="firstname" class="dis-flex-4 text_grey_2"
                      >First Name<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="firstname"
                      formControlName="firstname"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter First Name"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['firstname'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['firstname'].errors?.['required']"
                        >First Name is required</small
                      >
                    </div>
                  </div>
                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="Last Name" class="dis-flex-4 text_grey_2"
                      >Last Name<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="Last Name"
                      formControlName="lastname"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Last Name"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['lastname'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['lastname'].errors?.['required']"
                        >Last Name is required</small
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="dis-grid-2 width-100-per sign_up_modal_body_form3_boxes_box2"
                >
                  <div class="dis-block-1 p-top-18 p-x-20">
                    <div class="text_align">
                      <label class="text_grey_2"
                        >Phone<span class="text-danger">*</span></label
                      >
                    </div>
                    <div class="width-100-per">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        class="text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                        placeholder="626 611 7944"
                        formControlName="mobile_no"
                      />
                      <div
                        *ngIf="
                          isSubmitted &&
                          signUpForm.controls['mobile_no'].invalid
                        "
                        class="text-start"
                      >
                        <small
                          class="text-red-1 text_align"
                          *ngIf="signUpForm.controls['mobile_no'].errors?.['required']"
                          >Phone number is required</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="email2" class="dis-flex-4 text_grey_2"
                      >Email<span class="text-danger">*</span></label
                    >
                    <input
                      type="email"
                      id="email2"
                      formControlName="email"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Email"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['email'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['email'].errors?.['required']"
                        >Email is required</small
                      >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['email'].errors?.['email']"
                        >Invalid email address</small
                      >
                    </div>
                  </div>

                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="email3" class="dis-flex-4 text_grey_2"
                      >Education<span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      id="email3"
                      formControlName="education"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Education"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['education'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['education'].errors?.['required']"
                        >Education is required</small
                      >
                    </div>
                  </div>
                  <div class="dis-block-1 p-top-18 p-x-20">
                    <label for="email4" class="dis-flex-4 text_grey_2"
                      >Password<span class="text-danger">*</span></label
                    >
                    <input
                      type="password"
                      id="email4"
                      formControlName="password"
                      class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
                      placeholder="Enter Password"
                      required
                    />
                    <div
                      *ngIf="
                        isSubmitted && signUpForm.controls['password'].invalid
                      "
                      class="text-start"
                    >
                      <small
                        class="text-red-1 text_align"
                        *ngIf="signUpForm.controls['password'].errors?.['required']"
                        >Password is required</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text_align p-top-24 p-x-15 sign_up_modal_body_data1">
              <span class="text_black_14">Terms and conditions:</span>
              <p class="text_black_13">
                We want you to know how our website works and how we use your
                information when you register for the ChemRobotics. Please
                confirm that you have read and agree to these terms before
                continuing.
              </p>
              <div class="dis-flex-4">
                <div class="dis-flex-2">
                  <input
                    type="checkbox"
                    id="checkbox"
                    class="m-1"
                    name="checkbox"
                    value="yes"
                  />
                  <div class="text_black_13 p-l-3">
                    I agree to the<span class="text_blue_2 cursor-pointer">
                      terms of use</span
                    >
                    and<span class="text_blue_2 cursor-pointer">
                      privacy policy</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="text_align p-top-18 p-x-15 sign_up_modal_body_data2">
              <span class="text_black_14">Contact permission:</span>
              <p class="text_black_13">
                We'd like to keep you updated with news about the ChemRobotics,
                new services and features by email. We treat your personal
                information with care and will never sell them to other
                companies for marketing purposes.
              </p>
              <p class="text_black_13">
                Please let us know if you would like to be contacted by
                selecting one of the options below.
              </p>
              <div class="sign_up_modal_body_data2_box">
                <div class="p-x-5">
                  <label class="radio-item text_black_13">
                    <input
                      type="radio"
                      value="true"
                      formControlName="notify_update"
                    />
                    Yes please, keep me updated with news about the ChemRobotics
                  </label>
                </div>
                <div class="p-x-5">
                  <label class="radio-item p-x-15 text_black_13">
                    <input
                      type="radio"
                      value="false"
                      formControlName="notify_update"
                    />
                    No thanks, I do not want to be updated with news about the
                    ChemRobotics
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="dis-grid-2">
            <div class="m-t-20">
              <re-captcha
                class="m-t-20"
                (resolved)="onCaptchaSuccess($event)"
                [siteKey]="recaptchaSiteKey"
              >
              </re-captcha>
            </div>

            <div class="p-top-10 p-b-20 p-x-40 sign_up_modal_body_button1">
              <div class="sign_up_modal_body_button1_one">
                <button
                  class="text_blue_4 button_white_3"
                  (click)="previousForm()"
                >
                  Previous
                </button>
              </div>

              <div class="sign_up_modal_body_button1_two">
                <button type="submit" class="button_blue_4 text_white_1">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
